import React from "react";

import styled from "styled-components";
import { media } from "../components/_includes/Device";

import { SimpleHero } from "../components/SimpleHero";

import heroImage from "../assets/images/banners/strategy.jpg";

const Container = styled.div`
  padding: 45px 20px;
  margin: 45px auto;
  max-width: 800px;
  position: relative;

  .content {
    margin-top: 45px;
    padding: 45px 0;
    position: relative;

    &:before {
      content: "";
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
      height: 100%;
      width: 200vw;
      background: #f8f8f8;
      z-index: -1;
    }
  }

  ${media.tablet`
    padding: 35px 20px;
    display: block;
    margin: 0;
  `}
`;

export default class PrivacyNL extends React.Component {
  render() {
    return (
      <div>
        <SimpleHero
          title="Privacybeleid voor sollicitanten"
          heroImage={heroImage}
        />

        <Container>
          <p>
            Als je bij Picnic solliciteert, wil je niet dat je persoonlijke
            gegevens bij Jan en alleman terechtkomen. En terecht. Daarom nemen
            we jouw privacy serieus.
          </p>

          <p>
            Ook vinden we het belangrijk dat je begrijpt welke gegevens we
            verzamelen en wat we daarmee doen. We hebben ons privacybeleid
            daarom zo duidelijk mogelijk opgeschreven.
          </p>

          <p>
            Om te beginnen: we willen je sollicitatieprocedure zo soepel
            mogelijk laten verlopen. Daarbij gebruiken we jouw persoonlijke
            gegevens. Je kunt erop vertrouwen dat we zorgvuldig met je gegevens
            omgaan en dat we ons daarbij netjes houden aan de wet- en
            regelgeving.
          </p>

          <div className="content">
            <h3>Inhoud</h3>

            <ol>
              <li>
                <a href={"#1"}>Wanneer is dit privacybeleid van toepassing?</a>
              </li>
              <li>
                <a href={"#2"}>Wie is Picnic?</a>
              </li>
              <li>
                <a href={"#3"}>
                  Welke gegevens en informatie verzamelt en verwerkt Picnic?
                </a>
              </li>
              <li>
                <a href={"#4"}>
                  Voor welke doelen verwerken jullie deze gegevens?
                </a>
              </li>
              <li>
                <a href={"#5"}>
                  Wat zijn de juridische gronden voor het gebruik van mijn
                  gegevens?
                </a>
              </li>
              <li>
                <a href={"#6"}>Hoe zit het met cookies?</a>
              </li>
              <li>
                <a href={"#7"}>
                  Welke derden hebben toegang tot mijn gegevens?
                </a>
              </li>
              <li>
                <a href={"#8"}>Hoe beveiligen jullie mijn gegevens?</a>
              </li>
              <li>
                <a href={"#9"}>Hoe lang bewaren jullie mijn gegevens?</a>
              </li>
              <li>
                <a href={"#10"}>
                  Hoe gaan jullie om met de gegevens van minderjarigen?
                </a>
              </li>
              <li>
                <a href={"#11"}>
                  Hoe kan ik mijn gegevens inzien, wijzigen, verbeteren of
                  verwijderen?
                </a>
              </li>
              <li>
                <a href={"#12"}>Kan dit privacybeleid worden gewijzigd?</a>
              </li>
            </ol>

            <h3 id={"1"}>1. Wanneer is dit privacybeleid van toepassing?</h3>
            <p>
              Dit privacybeleid is van toepassing op alle gegevens die we
              verzamelen, gebruiken en opslaan van onze sollicitanten en andere
              gebruikers van onze Join Picnic-website.
            </p>

            <p>
              Er is één uitzondering: op de website vind je een paar links naar
              websites van derden. Voor de verwerking van je gegevens via deze
              websites zijn die derden zelf verantwoordelijk, dus het
              privacybeleid van Picnic is daarop niet van toepassing.
            </p>

            <h3 id={"2"}>2. Wie is Picnic?</h3>
            <p>
              Picnic is een techbedrijf in de retailsector. Ons kantoor kan je
              vinden aan de Van Marwijk Kooystraat 15, 1114 AG in Amsterdam.
            </p>

            <p>
              Afhankelijk van waar je tewerkgesteld kan worden, kunnen
              verschillende Picnic-bedrijven verantwoordelijk zijn voor de
              verwerking van de persoonsgegevens zoals we beschrijven in dit
              privacybeleid. Alle Picnic-bedrijven zijn te bereiken door te
              mailen naar privacy@picnic.nl of te whatsappen naar 088-3742642.
            </p>

            <h3 id={"3"}>
              3. Welke gegevens en informatie verzamelt en verwerkt Picnic?
            </h3>
            <p>
              Als je onze website gebruikt, verzamelen we drie soorten gegevens:
            </p>
            <ul>
              <li>
                <h4>Gegevens die je ons zelf hebt verstrekt</h4>
                <p>
                  Dit zijn onder meer de gegevens die je opgeeft als je bij
                  Picnic solliciteert. Bijvoorbeeld je naam, e-mailadres en
                  telefoonnummer, zodat we weten wie je bent en contact kunnen
                  opnemen als dat nodig is. Verder verstrek je ook zelf gegevens
                  als je met ons belt, mailt of whatsappt.
                </p>
              </li>

              <li>
                <h4>Automatisch gegenereerde gegevens</h4>
                <p>
                  Om onze website fatsoenlijk te kunnen laten werken, verzamelen
                  we ook automatisch gegenereerde informatie. Daarbij moet je
                  denken aan je IP-adres, de pagina’s die je bezoekt op onze
                  website en hoe lang dat duurt, de browser die je gebruikt en
                  het versienummer, en de Uniform Resource Locators-clickstream.
                  Dat laatste betekent dat we opslaan waar je vandaan komt en
                  naartoe gaat als je onze website bezoekt of hebt bezocht. Tot
                  slot slaan we het telefoonnummer waarmee je ons belt op. Zo
                  kunnen we je terugbellen als dat nodig is.
                </p>
              </li>

              <li>
                <h4>Informatie uit andere bronnen</h4>
                <p>
                  Soms verwerken we bij het behandelen van je sollicitatie
                  informatie uit externe bronnen, zoals referenties die in je cv
                  staan. Ook kan het zo zijn dat we je gegevens krijgen van
                  recruitmentbureaus of headhunters. Als je via zo’n instantie
                  met ons in contact komt, zorgen we er altijd voor dat je weet
                  hoe je gegevens bij ons terechtgekomen zijn.
                </p>
              </li>
            </ul>

            <p>
              Wil je weten waarvoor we die gegevens gebruiken? Lees dan verder
              in deel 4. Daarin vind je nog meer informatie over de
              gegevenscategorieën hierboven.
            </p>

            <h3 id={"4"}>
              4. Voor welke doelen verwerken jullie deze gegevens?
            </h3>
            <h4>Jouw sollicitatie</h4>
            <p>
              Als eerste stap in je sollicitatie bij Picnic vul je je gegevens
              in op onze website. Hier is het verplicht een geldige voor- en
              achternaam, e-mailadres, telefoonnummer, CV en beschikbaarheids-
              en andere preliminaire gegevens in te voeren. Zonder deze gegevens
              kunnen we namelijk je sollicitatie niet goed verwerken. De
              gegevens die je aan ons doorgeeft kun je altijd aanpassen.
            </p>

            <h4>Jouw gebruik van de website</h4>
            <p>
              Als je de website bezoekt, gebruiken we automatisch gegenereerde
              gebruiksinformatie. Dat doen we in de eerste plaats om de website
              fatsoenlijk te laten werken. We kunnen daarbij software gebruiken
              om bezoekgegevens te meten en verzamelen, bijvoorbeeld
              responstijden, errors en interactiegegevens (zoals scrol- en
              klikgedrag). Deze gegevens gebruiken we ook voor het beveiligen
              van Picnic. Tot slot koppelen we gegevens aan de informatie die je
              ons eerder hebt doorgegeven, bijvoorbeeld als je eerder bij ons
              hebt gesolliciteerd.
            </p>

            <h4>Beoordelingen</h4>
            <p>
              Sommige functies vereisen specifieke vaardigheden, die we je
              vragen te laten zien tijdens het sollicitatieproces. Als je
              bijvoorbeeld solliciteert voor een analytische functie, kunnen we
              je vragen om een kleine analytische test te maken. We gebruiken
              deze tests alleen om ervoor te zorgen dat de juiste mensen op de
              juiste plekken terechtkomen, en we houden je altijd op de hoogte
              van de uitslag.
            </p>

            <h4>Social media</h4>
            <p>
              Met behulp van een zogenaamde social plug-in kun je vacatures op
              onze website met anderen delen via e-mail of een social
              media-account (Facebook, Twitter, WhatsApp en Instagram). Via de
              social plug-in kunnen door derde partijen cookies worden
              geplaatst. Meer over cookies vertellen we je in ons cookiebeleid.
              In plaats van ons eigen privacybeleid, zijn op het plaatsen en
              gebruik van cookies door die derde partijen de voorwaarden van de
              betreffende social-mediaplatformen van toepassing.
            </p>

            <p>
              Andersom kun je ons ook zelf via je social media-account
              benaderen. Bijvoorbeeld via Facebook Messenger of WhatsApp. Het
              kan zijn dat je ons daarbij dan persoonlijke informatie verstrekt.
              Wij gebruiken die informatie dan om te reageren op je berichtje,
              maar kunnen deze ook opslaan bij de gegevens die we al over je
              hebben zodat we weten waar we het in het verleden met je over
              hebben gehad.
            </p>

            <h3 id={"5"}>
              5. Wat zijn de juridische gronden voor het gebruik van mijn
              gegevens?
            </h3>
            <p>
              Nu volgt een stukje in juristentaal. Als dat je niets zegt, dan
              kun je dit deel gerust overslaan. In deel 4 hebben we namelijk
              alles al gezegd wat je moest weten over de verwerkingsdoelen van
              jouw gegevens.
            </p>

            <p>
              Wij verwerken jouw gegevens op basis van de volgende “juridische”
              gronden: op basis van jouw toestemming (die je trouwens altijd
              weer kunt intrekken), noodzaak voor de uitvoering van een met jou
              gesloten overeenkomst of (pre)contractuele verhouding (zoals de
              administratie van ons recruitmentproces) en de “gerechtvaardigde
              belangen” van Picnic of een derde. We kunnen ook een wettelijke
              plicht hebben om je gegevens te verwerken, bijvoorbeeld wanneer we
              fraude vermoeden.
            </p>

            <p>
              Wanneer we je gegevens verwerken op basis van een “gerechtvaardigd
              belang” vinden wij dat de belangen van Picnic of een derde zo’n
              verwerking rechtvaardigen. Uiteraard zullen we in zo’n geval
              redelijke stappen ondernemen om te voorkomen dat andere afgewogen
              belangen (zoals jouw privacy) onnodig worden geschaad.
              “Gerechtvaardigd belang” is bijvoorbeeld de juridische grondslag
              van onze analyse van respons op vacatures, om onze dienstverlening
              en direct marketing te verbeteren. In deel 4 kun je uitgebreid
              lezen hoe we jouw informatie gebruiken om dat te doen. Een ander
              voorbeeld waarin we informatie verwerken op grond van
              “gerechtvaardigd belang”, zijn verwerkingen om onze website te
              beveiligen.
            </p>

            <p>
              Als je vragen hebt over de verwerkingen op basis van deze
              grondslag of gebruik wilt maken van je recht van verzet (want dat
              heb je uiteraard, onder andere als je vindt dat wij niet genoeg
              rekening houden met jouw belangen), dan kun je ons altijd mailen
              op privacy@teampicnic.com.
            </p>

            <h3 id={"6"}>6. Hoe zit het met cookies?</h3>
            <p>
              Net als bijna alle andere websites, gebruikt ook de Join
              Picnic-website cookies. Cookies zijn kleine informatiebestanden
              die jouw computer of mobiele apparaat opslaat wanneer je een
              website gebruikt. Veel cookies zorgen ervoor dat je een website
              goed kunt gebruiken. Dankzij cookies hoef je bijvoorbeeld niet
              steeds opnieuw in te loggen of steeds dezelfde informatie te
              downloaden als je een website opnieuw bezoekt. Andere cookies
              helpen om te zien hoe een website wordt gebruikt, of om gericht
              met gebruikers te kunnen communiceren.
            </p>

            <p>
              Door de websites van Picnic te gebruiken kunnen cookies op jouw
              apparaat worden geplaatst, en kan toegang tot die cookies worden
              verkregen. Cookies van Picnic kunnen je computer, telefoon of
              tablet of de bestanden die daarop staan niet beschadigen.
            </p>

            <p>
              Vooropgesteld: onze website werkt prima als je ervoor gekozen hebt
              om helemaal geen cookies te accepteren (dus ook niet die van
              Picnic). Advertentiecookies plaatsen en gebruiken we bovendien
              alleen maar als je daarvoor toestemming hebt gegeven. Of je dat
              wel of niet doet moet je natuurlijk helemaal zelf weten. Wel
              kunnen we onze website wat gebruiksvriendelijker maken als je ze
              accepteert.
            </p>

            <p>
              In ons cookiebeleid vind je meer informatie over de cookies die we
              gebruiken, waar ze voor dienen en hoe je zelf kunt bepalen welke
              soorten we gebruiken. Ook kun je daar meer lezen over het gebruik
              van reclame-ID’s, wat we daarmee doen en hoe je die uit kunt
              zetten.
            </p>

            <h3 id={"7"}>7. Welke derden hebben toegang tot mijn gegevens?</h3>
            <p>
              Jouw privégegevens blijven privé. Dat betekent dat we je
              persoonlijke informatie nooit zonder jouw toestemming delen met
              derde partijen voor marketing-doeleinden. De enige partijen
              waarmee we zonder jouw toestemming gegevens zullen delen zijn:
            </p>

            <h4>Onze eigen groepsvennootschappen</h4>
            <p>
              We willen natuurlijk dat alle administraties en huishoudboekjes
              binnen Picnic met elkaar kloppen. Daarom delen Picnic B.V, Picnic
              Fulfillment B.V., Picnic Hubs B.V., Picnic Services B.V., Picnic
              Technologies B.V. en Picnic International B.V. deze gegevens
              onderling.
            </p>

            <ul>
              <li>
                Picnic B.V. beheert de online winkel waar klanten boodschappen
                kunnen bestellen.
              </li>
              <li>
                Picnic Fulfillment B.V. is verantwoordelijk voor het verwerken,
                opslaan en inpakken van producten.
              </li>
              <li>
                Picnic Hubs B.V. zorgt ervoor dat producten bij klanten worden
                thuisbezorgd.
              </li>
              <li>
                Picnic Services B.V. houdt zich bezig met onze
                hoofdkantooractiviteiten.
              </li>
              <li>
                Picnic Technologies B.V. ontwikkelt en beheert onze software.
              </li>
              <li>Picnic International B.V. is ons moederbedrijf.</li>
            </ul>

            <h4>Onderaannemers en dienstverleners die we vertrouwen</h4>
            <p>
              Met deze partijen zullen we steeds gedetailleerde afspraken maken
              over hoe we jouw privacy en die van andere klanten kunnen
              beschermen.
            </p>

            <h4>Met een partij die ons wil overnemen of met ons wil fuseren</h4>
            <p>
              In het zéér onwaarschijnlijke geval dat dat ooit gaat gebeuren :)
            </p>

            <h4>
              Toezichthouders, fiscale autoriteiten of opsporingsinstanties
            </h4>
            <p>
              Als we denken dat we verplicht zijn op basis van de wet- of
              regelgeving.
            </p>

            <h4>De rechter en wederpartijen</h4>

            <p>
              In een rechtszaak waarin jouw gegevens als bewijs van belang zijn.
            </p>
            <p>
              Ook als je persoonsgegevens worden doorgegeven naar landen buiten
              de Europese Unie, zorgen we ervoor dat jouw privacy zo goed
              mogelijk beschermd blijft. We werken dan bijvoorbeeld met Europese
              modelcontracten die speciaal voor dit soort gevallen zijn
              opgesteld.
            </p>

            <h3 id="8">8. Hoe beveiligen jullie mijn gegevens?</h3>
            <p>
              We vinden het belangrijk dat jouw informatie goed beveiligd wordt
              opgeslagen. Daarom hebben we serieuze technische en
              organisatorische maatregelen genomen om jouw gegevens te
              beveiligen tegen verlies of tegen enige vorm van onrechtmatige
              verwerking. Zo beveiligen we onze systemen en applicaties volgens
              de geldende standaarden voor informatiebeveiliging, zoals Control
              Objectives for Information and related Technology (CobiT) en de
              Standard of Good Practice for Information Security (ISF).
            </p>

            <h3 id="9">9. Hoe lang bewaren jullie mijn gegevens?</h3>
            <p>
              We bewaren je gegevens niet langer dan nodig en in elk geval
              zolang het recruitmentproces duurt. Mocht je zonder succes hebben
              gesolliciteerd, dan kunnen we je gegevens bewaren voor het geval
              we je een functie willen aanbevelen en om ons recruitmentproces te
              analyseren en te verbeteren. Als je bent aangenomen, zal de
              informatie die verzameld is tijdens het recruitmentproces deel
              gaan uitmaken van het personeelsbestand. Die informatie valt dan
              niet meer onder dit privacybeleid. Als je een vraag hebt over de
              precieze bewaartermijn van bepaalde soorten gegevens, stuur dan
              gerust een mail naar privacy@teampicnic.com
            </p>

            <h3 id="10">
              10. Hoe gaan jullie om met de gegevens van minderjarigen?
            </h3>
            <p>
              Om bij Picnic te kunnen werken, moet je 18 jaar of ouder zijn. We
              verzamelen dus geen gegevens van personen die jonger zijn dan 18
              jaar voor verwerkingen waar we toestemming voor nodig hebben.
            </p>

            <h3 id={"11"}>
              11. Hoe kan ik mijn gegevens inzien, wijzigen, verbeteren of
              verwijderen?
            </h3>
            <p>
              Natuurlijk blijf je zelf de baas over je eigen gegevens. Daarom
              kun je op elk moment inzage vragen in de informatie die we van jou
              hebben opgeslagen en gebruiken. Ook kun je altijd gegevens
              wijzigen of verwijderen. Ten slotte heb je ook het recht van
              verzet tegen onze verwerkingen van je gegevens.
            </p>

            <p>
              Om je dat alles makkelijk te maken, kun je bij ons een speciaal
              formulier opvragen waarin we je helpen zo’n verzoek gemakkelijk
              tot uitdrukking te brengen. Natuurlijk kun je ons je verzoek ook
              gewoon in je eigen woorden mailen, of per post opsturen.
            </p>

            <p>
              Als je een verzoek indient of je recht van verzet uitoefent,
              vragen we je om een geldig legitimatiebewijs mee te sturen. Zo
              weten we zeker dat jij het bent en voorkomen we dat iemand anders
              er met je gegevens vandoor gaat. Maak voor de veiligheid wel even
              het BSN-nummer onleesbaar en je pasfoto onherkenbaar.
            </p>

            <p>
              Heb je nog vragen over ons privacybeleid? Je mag ons altijd mailen
              op privacy@teampicnic.com. Ben je niet tevreden met de manier
              waarop je jouw privacyverzoek hebben afgehandeld? Dan kun je
              altijd je klacht indienen bij de Autoriteit Persoonsgegevens.
            </p>

            <h3 id="12">12. Kan dit privacybeleid worden gewijzigd?</h3>
            <p>
              Dit privacybeleid kan inderdaad wijzigen. Bijvoorbeeld naar
              aanleiding van nieuwe wet- of regelgeving. De laatste, actuele
              versie van het privacybeleid vind je altijd op
              join.picnic.app/privacy. Daarin zetten we ook steeds de laatste
              datum van wijziging. Als we dingen wijzigen in ons beleid die voor
              jou belangrijk zijn, dan laten we dat natuurlijk ook op andere
              manieren aan je weten (bijvoorbeeld via e-mail).
            </p>
          </div>
        </Container>
      </div>
    );
  }
}
